import { CreateNewPatient } from 'domain/usecases/patient/create-new-patient'
import { PatientNewRepository } from 'repository/interfaces/patient-new-repository'

export class RemoteCreateNewPatient implements CreateNewPatient {
  private readonly patientNewRepository: PatientNewRepository

  constructor(patientNewRepository: PatientNewRepository) {
    this.patientNewRepository = patientNewRepository
  }

  create(params: CreateNewPatient.Params): Promise<CreateNewPatient.Model> {
    return this.patientNewRepository.createNewPatient(params)
  }
}
